import { ChangeDetectionStrategy, Component, computed, model, output, Signal, ViewEncapsulation } from '@angular/core';

import { TiimeIconModule } from '../icon/icon.module';

import { PaginationRange } from './pagination-range';

@Component({
  selector: 'tiime-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TiimeIconModule]
})
export class PaginatorComponent {
  readonly range = model(new PaginationRange());
  readonly rangeEvent = output<PaginationRange>();

  readonly pagerDisplay: Signal<string> = computed(() => {
    return `${this.range().min + 1} à ${this.range().max + 1}`;
  });

  readonly hasPreviousPage: Signal<boolean> = computed(() => {
    return !!this.range().previous();
  });

  readonly hasNextPage: Signal<boolean> = computed(() => {
    return !!this.range().next();
  });

  readonly shouldDisplay: Signal<boolean> = computed(() => {
    return this.range() && (this.hasPreviousPage() || this.hasNextPage());
  });

  previousPage(): void {
    const range: PaginationRange | undefined = this.range().previous();
    if (range) {
      this.rangeEvent.emit(range);
    }
  }

  nextPage(): void {
    const range: PaginationRange | undefined = this.range().next();
    if (range) {
      this.rangeEvent.emit(range);
    }
  }
}
